import { LockKeyhole } from "lucide-react";

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <div className={`brand ${compact ? "brand--compact" : ""}`} aria-label="DickerTicker">
      <div className="brand__mark" aria-hidden="true"><span className="brand__initials">DT</span><span className="brand__digits">001</span></div>
      <div>
        <span className="brand__name"><span>Dicker</span><span>Ticker</span></span>
        {!compact && <span className="brand__promise"><LockKeyhole size={13} /> Private by default</span>}
      </div>
    </div>
  );
}
